import {get} from 'lodash';

export default (state = {}, {clientId, stateName, stateValue}: any) => {
  return {
    ...state,
    allNotesState: {
      ...get(state, 'allNotesState', {}),
      [clientId]: {
        ...get(state, `allNotesState.${clientId}`, {}),
        [stateName]: stateValue,
      },
    },
  };
};
